




import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class App extends Vue {
  @Prop({ default: "" }) public myAtty!: string;
}
